import { accordionSummaryDefaultStyle, containerStyle, imageStyle } from './accordionSummaryDefaultStyle';
export const containereBuilder = theme => containerStyle(theme);
export const imageBuilder = theme => imageStyle(theme);
const accordionSummaryStyleBuilder = (theme, chevronPosition, contained) => {
  const style = accordionSummaryDefaultStyle(theme, chevronPosition, contained);
  return style;
};
export default accordionSummaryStyleBuilder;